// extracted by mini-css-extract-plugin
export default {"Tab":"styles_Tab__yjgX4","active":"styles_active__eJr6v"};